import { PngIcoConverter } from './png2icojs';

interface ISaveToPngResult {
    pngImgDataUrl: string,
    blob: Blob|null,
}

export const svgToPng = ($svg: SVGSVGElement) => {

    return new Promise<ISaveToPngResult>((resolve, reject) => {
        const $canvas = document.createElement('canvas');
        $canvas.width = $svg.width.baseVal.value;
        $canvas.height = $svg.height.baseVal.value;

        const ctx = $canvas.getContext('2d');
        if(!ctx){
            reject();
            return null;
        }

        // prepare svg data
        const data = (new XMLSerializer()).serializeToString($svg);
        const svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});

        const DomURL = window.URL || window.webkitURL || window;
        const url = DomURL.createObjectURL(svgBlob);

        const $img = new Image();
        $img.onload = () => {
            ctx.clearRect(0, 0, $canvas.width, $canvas.height);
            ctx.drawImage($img, 0, 0);

            DomURL.revokeObjectURL(url);

            // 'image/x-icon' type works only in firefox, so it's not an option
            const pngImgDataUrl = $canvas.toDataURL('image/png');

            $canvas.toBlob(blob => {
                resolve({
                    pngImgDataUrl,
                    blob
                });
            });
        };

        $img.src = url;
    });
};

export const blobToBase64 = (blob: Blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};

/**
 * Ico format: https://en.wikipedia.org/wiki/ICO_%28file_format%29#Outline
 * Github gist: https://gist.github.com/twolfson/7656254
 */
export const pngToIco = async ($svg16: SVGSVGElement, $svg32: SVGSVGElement, $svg48: SVGSVGElement) => {

    const svgToPngResult16 = await svgToPng($svg16);
    const svgToPngResult32 = await svgToPng($svg32);
    const svgToPngResult48 = await svgToPng($svg48);

    if(!svgToPngResult16 || !svgToPngResult32 || !svgToPngResult48) return null;

    // https://stackoverflow.com/questions/12168909/blob-from-dataurl
    // An ArrayBuffer can be manipulated by using TypedArrays and DataView, whereas Blob is immutable.
    // const blob = await (await fetch(base64PngDataUrl)).blob();
    const arrayBuffer16 = await (await fetch(svgToPngResult16.pngImgDataUrl)).arrayBuffer();
    const arrayBuffer32 = await (await fetch(svgToPngResult32.pngImgDataUrl)).arrayBuffer();
    const arrayBuffer48 = await (await fetch(svgToPngResult48.pngImgDataUrl)).arrayBuffer();

    const inputs = [arrayBuffer16, arrayBuffer32, arrayBuffer48].map(file => ({
        png: file
    }));

    // result is a blob
    const converter = new PngIcoConverter();
    const resultBlob = await converter.convertToBlobAsync(inputs); // default mime type is image/x-icon

    const base64 = await blobToBase64(resultBlob) as string;

    return {
        blob: resultBlob,
        base64
    };
};
